import React from 'react';
import { DashboardView } from './components/DashboardView';

export const DashboardTab: React.FC = () => {
  return <DashboardView />;
};